// extracted by mini-css-extract-plugin
export default {"packages_table":"programs-edit_packages_table__bMa5U","reorder_buttons":"programs-edit_reorder_buttons__ml6Wq"};